import type { CSSObject } from "@emotion/react";

export const placeholder = (style: CSSObject) => {
  return {
    "::-webkit-input-placeholder": style,
    "::-moz-placeholder": style,
    ":-ms-input-placeholder": style,
    ":-moz-placeholder": style,
  };
};
